export default class SimpleSlider
{
    constructor(selector) {
        this._translateX = 0;
        this.el = jQuery(selector).eq(0);
        this.ul = this.el.find('.subcategories, .woocommerce-product-gallery__wrapper');
        this.slideNum = this.ul.find('li, .woocommerce-product-gallery__image').length;
        this.columns = window.innerWidth <= 800 ? 2 : 4;

        this.setColNr = this.setColNr.bind(this);
        this.moveSlides = this.moveSlides.bind(this);

        this.init();
    }

    init()
    {
        if (this.slideNum > 2) {
            this.el.addClass('slider-active');
            this.el.find('.slide-arrow').click(this.moveSlides);
            window.onresize = this.setColNr;
        }
    }

    set translateX(n) {
        const slidesWidth = (this.ul.find('.subcategory, .woocommerce-product-gallery__image').width() + 16) * this.slideNum - 16;
        const maxRight = (slidesWidth - (this.el.width() )) * -1;
        if (n <= maxRight) {
            this._translateX = maxRight;
            this.el.addClass('max-right');
        } else if (n >= 0) {
            this._translateX = 0;
            this.el.addClass('max-left');
        } else {
            this._translateX = n;
        }
    }

    get translateX() {
        return this._translateX;
    }


    setColNr(e) {
        this.translateX = 0;
        this.ul.css('transform', `translateX(${this.translateX}px)`);

        if (e.target.innerWidth <= 800 && this.columns !== 2) {
            this.columns = 2
        } else if (e.target.innerWidth > 800 && this.columns !== 4) {
            this.columns = 4
        }
    }

    moveSlides(e)
    {
        if (this.columns === this.slideNum) {
            return false;
        }
        const w = this.ul.find('.subcategory, .woocommerce-product-gallery__image').width() + 16;
        this.el.removeClass('max-right').removeClass('max-left');

        if (e.target.className.indexOf('slide-right') > -1) {
            this.translateX -= w;
        } else {
            this.translateX += w;
        }
        this.ul.css('transform', `translateX(${this.translateX}px)`);
    }
}